import { render, staticRenderFns } from "./r-map-addon-page.vue?vue&type=template&id=3368d15c"
import script from "./r-map-addon-page.vue?vue&type=script&lang=js"
export * from "./r-map-addon-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3368d15c')) {
      api.createRecord('3368d15c', component.options)
    } else {
      api.reload('3368d15c', component.options)
    }
    module.hot.accept("./r-map-addon-page.vue?vue&type=template&id=3368d15c", function () {
      api.rerender('3368d15c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/map-addon/addon/r-map-addon-page.vue"
export default component.exports